'use client';
import { useEffect, useRef } from 'react';
import ReactGA from 'react-ga4';

export function useDocumentTitle(title: string, prevailOnUnmount = false) {
  const defaultTitle = useRef(
    typeof document !== 'undefined' ? document.title : null
  );

  useEffect(() => {
    if (typeof window !== 'undefined') {
      document.title = title;
      ReactGA.send({
        hitType: 'pageview',
        page: window.location.pathname,
        title: title,
      });
    }
  }, [title]);

  useEffect(
    () => () => {
      if (
        !prevailOnUnmount &&
        typeof document !== 'undefined' &&
        defaultTitle.current
      ) {
        document.title = defaultTitle.current;
      }
    },
    []
  );
}
